export const getTranslationKey = (str, prefix = '') =>
  [prefix, ...str.split(' ')].reduce(
    (acc, item) => `${acc}${item[0].toUpperCase()}${item.slice(1)}`,
  );
